export default "__VITE_ASSET__2dooA6hD__"